import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { toast } from "sonner";
import PageBlocks from "@/components/site/PageBlocks";
import EditableText from "@/components/site/EditableText";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const nav = useNavigate();
  const { login, user } = useAuth();
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => { if (user) nav("/profil"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connecté·e !");
      nav("/profil");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Identifiants invalides");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-12">
      <h1 className="font-display font-black text-4xl tracking-tighter uppercase">Connexion</h1>
      <EditableText slug="login" sectionKey="subtitle" className="mt-2 text-neutral-700 [&_p]:m-0">
        <p>Connecte-toi pour suivre tes votes, gagner des badges et plus.</p>
      </EditableText>
      <PageBlocks slug="login" className="mt-5" />

      <button onClick={googleLogin} className="neo-btn bg-white w-full justify-center mt-6" data-testid="google-login-btn">
        <svg className="w-5 h-5" viewBox="0 0 24 24" aria-hidden="true"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.12A6.6 6.6 0 0 1 5.47 12c0-.74.13-1.46.36-2.12V7.04H2.18A11 11 0 0 0 1 12c0 1.78.43 3.46 1.18 4.96l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.07.56 4.21 1.64l3.16-3.16C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.04L5.84 9.88C6.71 7.28 9.14 5.38 12 5.38z"/></svg>
        Continuer avec Google
      </button>

      <div className="flex items-center gap-3 my-5">
        <div className="h-px bg-black flex-1" />
        <span className="text-xs font-bold uppercase tracking-widest text-neutral-500">ou</span>
        <div className="h-px bg-black flex-1" />
      </div>

      <form onSubmit={submit} className="grid gap-3" data-testid="user-login-form">
        <input className="neo-input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <input className="neo-input" type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        <button type="submit" disabled={loading} className="neo-btn bg-cef-blue text-white justify-center disabled:opacity-50" data-testid="login-submit">
          {loading ? "…" : "Se connecter"}
        </button>
      </form>

      <p className="mt-5 text-sm">Pas encore de compte ? <Link to="/signup" className="font-bold underline">Créer un compte</Link></p>
    </div>
  );
}
